import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { useAppSelector } from "app/redux/hooks"
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { adicionarItens } from "app/use-cases/orcamento/adicionarItens"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { ItensOrcamentoContainer } from "../itens-orcamento/ItensOrcamentoContainer"
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { EntitesSimilares, Similares } from "./Similares"
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto"

export type SimilaresContainerProps = {
    item: IItemOrcamento,
    onRemover: () => void,
    onVoltar: () => void,
    passos: Dict<string, () => void>
    foraOrcamento: boolean
}

export const SimilaresContainer = (props: SimilaresContainerProps) => {
    const orcamento: IOrcamento = props.foraOrcamento ? {} :useAppSelector((store) => store.orcamento);
    const [similares, setSimilares] = useState<PagedMessageResponse<EntitesSimilares>>()
    const [parametros, setParametros] = useState<Parametro[]>([])

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
    useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)

    const onObterDadosProdutosSimilares = async (numeroPagina?: number) => {
        try {
            globalMU.blockUI();
            const similaresPesquisados = await microuniversoApi.Produto.consultarSimilares({
                Codigo: props.item.Codigo,
                NumeroPagina: numeroPagina ?? 1,
                TamanhoPagina: 20,
            });
            ("HasErrors" in similaresPesquisados || similaresPesquisados?.Entities?.length == 0) ? (setSimilares({}), onVoltar()) : setSimilares(similaresPesquisados)
        } catch (e) {
            onVoltar()
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onVoltarGridItens = () => {
        
        renderizarComponentReact(
            < ItensOrcamentoContainer />,
            "conteudo-pagina",
            true
        )
    }

    const onAdicionarProdutosSimilares = async (similaresSelecionados: EntitesSimilares[]) => {
        try {
            if (similaresSelecionados.length == 0) {
                globalMU.showErrorMessage("Por favor, selecione os produtos a serem adicionados.");
                return;
            }

            await adicionarItens(orcamento.IdentificadorOrcamento, similaresSelecionados)
            onVoltarGridItens()

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI()
        }
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    // const atualizarParametros = async () => {
    //     setParametros(
    //       await obterParametros({
    //         nomes: [
    //           "CHAVE_MOVIMENTACAO_ORCAMENTO"
    //         ]
    //       })
    //     )
    //   }
    
    // const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    useEffect(() => {
        passosInterno.current.set("Similares", () => { renderizarComponentReact(<SimilaresContainer {...props} />, "conteudo-pagina", true) })
        onObterDadosProdutosSimilares()
        //atualizarParametros()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="SimilaresContainer"
                onBotaoVoltarClicado={onVoltar}
                onPassoSelecionado={onPassoSelecionado}
            />
            <Similares
                foraOrcamento={props.foraOrcamento}
                codigo={ props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != ""  ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd() }
                descricao={props.item.Descricao}
                dadosSimilares={similares}
                corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                onOk={onAdicionarProdutosSimilares}
                onPesquisarPaginado={onObterDadosProdutosSimilares}
            />
        </>
    )
}